<script lang="ts">
    import { floatingUiComponents } from "../../Utils/svelte-floatingui-show";

    interface Props {
        [key: string]: unknown;
    }

    let { ...rest }: Props = $props();
</script>

{#each [...$floatingUiComponents.entries()] as [key, value] (`${key}`)}
    {@const valueProps = value.props ?? {}}
    {@const Component = value.componentType}
    {@const action = value.action}
    <div class="absolute z-3000" style:z-index={value.zIndex} use:action>
        <Component {...rest} {...valueProps} />
    </div>
{/each}
